import { render, staticRenderFns } from "./SvgaDisplay.vue?vue&type=template&id=2997b85c&"
import script from "./SvgaDisplay.vue?vue&type=script&lang=js&"
export * from "./SvgaDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports